"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistryProgram = void 0;
const web3_js_1 = require("@solana/web3.js");
const program_1 = require("../base/program");
class RegistryProgram extends program_1.Program {
}
exports.RegistryProgram = RegistryProgram;
RegistryProgram.PUBKEY = new web3_js_1.PublicKey('RegYdXL5fJF247zmeLSXXiUPjhpn4TMYLr94QRqkN8P');
//# sourceMappingURL=registryProgram.js.map